import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { getSubcategoriesData } from "../../services/HomeServices";
import { toast } from "react-toastify";
import _ from "lodash";
import "./SubcategoryNavigation.css";
import noImageFound from "../../assets/images/no-image-found.jpg";

const SubcategoryNavigation = ({ categoryId }) => {
  const [subcategories, setSubcategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [searchParams, setSearchParams] = useSearchParams();
  const selectedSubcategoryId = searchParams.get("subcategory_id");

  useEffect(() => {
    if (categoryId) {
      fetchSubcategories();
    } else {
      setSubcategories([]);
    }
  }, [categoryId]);

  const fetchSubcategories = async () => {
    setIsLoading(true);
    try {
      const response = await getSubcategoriesData(categoryId);
      setSubcategories(response?.data?.data || []);
    } catch (error) {
      console.error("Error fetching subcategories:", error);
      toast("Failed to load subcategories", { type: "error" });
      setSubcategories([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSubcategoryClick = (subcategoryId) => {
    if (selectedSubcategoryId === String(subcategoryId)) {
      const newParams = new URLSearchParams(searchParams);
      newParams.delete("subcategory_id");
      setSearchParams(newParams);
    } else {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("subcategory_id", subcategoryId);
      setSearchParams(newParams);
    }
  };

  if (!categoryId) {
    return null;
  }

  if (isLoading) {
    return (
      <section className="subcategory-navigation">
        <div className="subcategory-container">
          <div className="loading-container">
            <div className="modern-spinner"></div>
          </div>
        </div>
      </section>
    );
  }

  if (_.isEmpty(subcategories)) {
    return (
      <section className="subcategory-navigation">
        <div className="subcategory-container">
          <div className="empty-state-small">
            <i className="far fa-info-circle"></i>
            <span>No subcategories available for this category</span>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="subcategory-navigation">
      <div className="subcategory-container">
        <div className="subcategory-header">
          <i className="far fa-layer-group"></i>
          <h3>Select Subcategory</h3>
        </div>

        <div className="subcategory-scroll-wrapper">
          {subcategories.map((subcategory) => (
            <button
              key={subcategory.id}
              className={`subcategory-pill ${
                selectedSubcategoryId === String(subcategory.id) ? "active" : ""
              }`}
              onClick={() => handleSubcategoryClick(subcategory.id)}
            >
              <div className="subcategory-image">
                <img
                  src={subcategory.image || noImageFound}
                  alt={subcategory.name}
                  loading="lazy"
                  onError={(e) => {
                    e.target.src = noImageFound;
                  }}
                />
              </div>
              <span className="subcategory-name">{subcategory.name}</span>
              {selectedSubcategoryId === String(subcategory.id) && (
                <i className="far fa-check subcategory-check"></i>
              )}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SubcategoryNavigation;
